import { Observable } from "rxjs";

import { get, post } from "@utils/axios";
import sessionService from "./session.service";

class WellBeEMPIService {
  getPayersList(): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/empi/payers`);
  }

  getPendingProcessingStatus(): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/empi/status`);
  }

  getColumnsList({ pageName }: any): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/empi/column-list?pageName=${pageName}`);
  }

  // getEmpiRecordsForInterventionCases({sortType, sortBy, pageNo, pageSize, payerName }:any): Observable<any> {
  //   let body = {
  //     sortType,
  //     sortBy,
  //     pageNo,
  //     pageSize,
  //     payerName,
  //     category: "interventionDetails",
  //   };

  //   return post(`${sessionService.getClient()?.appServiceUrl}/empi/intervention-cases`, body);
  // }

  createNewEmpi(payload: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/empi/pending-processing`, { ...payload });
  }

  mergeTwoEMPIs(payload: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/empi/pending-processing?isEMPIMerge=${true}`, { ...payload });
  }

  fetchExistingMatchingRecords(payload: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/empi/previous-match-records`, { ...payload });
  }

  fetchAllEMPIMasterData(payload: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/empi/all-empi-master`, { ...payload });
  }

  fetchPipeLineBatchList(payload: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/empi/data-quality/data-processing-batches`, { ...payload });
  }

  fetchDataProcessingPipeLineData(batchId: any, fileName: any): Observable<any> {
    let queryParams = `?batchId=${batchId}${fileName ? `&fileName=${fileName}` : ""}`;
    return get(`${sessionService.getClient()?.appServiceUrl}/empi/data-quality/data-processing-pipeline${queryParams}`);
  }

  fetchAttributeDropdown(attributeName: string) {
    let param = `attr_key_val=${attributeName}`;
    return post(`${sessionService.getClient()?.appServiceUrl}/empi/fetch-dropdown?${param}`);
  }


  // APIs Related to data quality report
  
  getFileTypeList(): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/empi/file-types`);
  }

  getScoreBoardData(payerName: string, fileType: string, startDate?: any, endDate?: any, failedFilesType?: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/empi/score-board`, {
      payerName: payerName,
      fileType: fileType,
      startDate,
      endDate,
      failedFilesType
    });
  }

  getScoreAnomalyGraphData(payerName: string, fileType: string): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/empi/fetch-score-anomaly-graph-data`, {
      payerName: payerName,
      fileType: fileType,
    });
  }

  getScoreAnomalyData(payerName: string, fileType: string, startDate?: any, endDate?: any,scoreType?: string, failedFilesType?: any): Observable<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/empi/fetch-score-anomaly`, {
      payerName: payerName,
      fileType: fileType,
      startDate,
      endDate,
      scoreType: scoreType,
      failedFilesType
    });
  }

  getFileTrackingData(filters:any) {
    return post(`${sessionService.getClient()?.appServiceUrl}/empi/fetch-file-tracking`, {
      ...filters
    });
  }

  getFilterableColumnAndOptions() {
    return get(`${sessionService.getClient()?.appServiceUrl}/empi/fetch-file-tracking/column-filter-option`)
  }

  getFileTrackingAvailableDates() {
    return get(`${sessionService.getClient()?.appServiceUrl}/empi/fetch-file-tracking/file-available-dates`)
  }

}

export default new WellBeEMPIService();
